import React from 'react';

type PageLayoutProps = {
  header?: React.ReactNode;
  children: React.ReactNode;
  contentPadding?: 'default' | 'lg' | 'sm' | 'none';
  className?: string;
};

const PageLayout: React.FC<PageLayoutProps> = ({
  header,
  children,
  contentPadding = 'default',
  className = '',
}) => {
  const paddingMap = {
    lg: 'container mx-auto px-4 md:px-6 lg:px-8 py-16',
    sm: 'container mx-auto px-4 md:px-6 lg:px-8 py-6',
    none: 'p-0',
    default: 'container mx-auto px-4 md:px-6 lg:px-8 py-10',
  };

  return (
    <div
      className={`min-h-screen flex flex-col bg-background text-foreground ${className}`.trim()}
      data-design-layout
    >
      {header && <header className="w-full">{header}</header>}
      <main className={`flex-grow ${paddingMap[contentPadding]}`}>{children}</main>
    </div>
  );
};

export default PageLayout;
